<template>
  <b-input-group>
    <file-explorer
      v-model="show_file_explorer"
      :path="local_path"
      :is_open="is_open"
      @change="update_path_from_modal"
    />
    <b-input-group-prepend v-c-tooltip="file_tooltip" is-text
      ><slot><span :class="file_icon"/></slot
    ></b-input-group-prepend>
    <b-input-group-prepend v-c-tooltip="$t('interpolated_string')"
      ><b-button
        :pressed.sync="local_contains_metavariables"
        :variant="metavariables_button_variant"
        ><span class="fas fa-code fa-fw"/></b-button
    ></b-input-group-prepend>
    <b-form-input v-model="local_path" :placeholder="file_tooltip" />
    <b-input-group-append v-c-tooltip="$t('open_file_explorer')">
      <b-button @click="show_file_explorer = true">&hellip;</b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<i18n>
{
  "en": {
    "file_load_location": "File load location",
    "file_save_location": "File save location",
    "interpolated_string": "Interpolated regular expression string which can reference metavariables",
    "open_file_explorer": "Open server file explorer..."
  },
  "fr": {
    "file_load_location": "Emplacement du fichier à charger",
    "file_save_location": "Emplacement où sauvegarder le fichier",
    "interpolated_string": "Chaîne de caractères interpolés avec expressions régulières pouvant référencer des métavariables",
    "open_file_explorer": "Ouvrir l'explorateur des fichiers du serveur..."
  }
}
</i18n>

<script>
import _ from 'lodash'

import { GenericPath } from '@/components/object_model.js'
import FileExplorer from '@/components/file_explorer.vue'

// *****************************************************************************

export default {
  name: 'FilepathSelector',
  components: { FileExplorer },
  model: {
    prop: 'generic_path',
    event: 'input',
  },
  props: ['generic_path', 'is_open', 'placeholder'],
  data() {
    return {
      local_path: '',
      local_contains_metavariables: false,
      show_file_explorer: false,
    }
  },
  computed: {
    file_tooltip() {
      let res
      if (this.is_open) {
        res = this.$t('file_load_location')
      } else {
        res = this.$t('file_save_location')
      }
      return res
    },
    file_icon() {
      let res
      if (this.is_open) {
        res = 'fas fa-file-upload fa-fw'
      } else {
        res = 'fas fa-file-download fa-fw'
      }
      return res
    },
    local_generic_path() {
      return new GenericPath(this.local_path, this.local_contains_metavariables)
    },
    metavariables_button_variant() {
      let res
      if (this.local_contains_metavariables) {
        res = 'secondary'
      } else {
        res = 'outline-secondary'
      }
      return res
    },
  },
  watch: {
    generic_path: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.destructure(nv)
        }
      },
    },
    local_generic_path(nv, ov) {
      if (!_.isEqual(nv, this.generic_path)) {
        this.$emit('input', this.local_generic_path)
      }
    },
  },
  methods: {
    destructure(nv) {
      this.local_path = (nv || {}).path || ''
      this.local_contains_metavariables =
        (nv || {}).contains_metavariables || false
    },
    update_path_from_modal(nv) {
      this.local_path = nv
    },
  },
}
</script>
